import { DaysPlannerService } from './days-planner.service';
import { LangService } from './lang.service';

export const SERVICES: any[] = [DaysPlannerService, LangService];

export * from './days-planner.service';
export * from './lang.service';